import { Link } from "@material-ui/core";
import { ColumnDefinition } from "components/LynxTable/ColumnDefinition";
import { separateThousands } from "helpers/separateThousands";
import { theme } from "styling/theme";
import { Link as RouterLink, useRouteMatch } from "react-router-dom";
import { RiskChip } from "components/RiskChip/RiskChip";
import { RouteDetails } from "models/routeDetails/RouteDetails";

export const laneViewRoutesTableColumns: ColumnDefinition<RouteDetails>[] = [
    {
        id: "routeId",
        headerTitle: "identifier",
        render: ({ routeId, routeName }: RouteDetails) => {
            const { url } = useRouteMatch();

            return (
                <Link
                    component={RouterLink}
                    to={`${url}/routes/${routeId}`}
                    style={{ color: theme.colors.primary.blue500 }}
                >
                    {routeName}
                </Link>
            );
        },
    },
    {
        // transportationMode
        id: "transportationMode",
        headerTitle: "mode(s) of transportation",
    },
    {
        id: "riskLevel",
        headerTitle: "risk level",
        render: ({ riskLevel }: RouteDetails) => (
            <RiskChip
                riskLevel={
                    riskLevel.toLowerCase() as
                        | "low"
                        | "high"
                        | "medium"
                        | "healthy"
                }
            />
        ),
        sortable: true,
        align: "center",
    },
    {
        id: "reason",
        headerTitle: "reason",
        sortable: true,
        align: "left",
    },
    {
        id: "alertsCount",
        headerTitle: "number of alerts",
        render: (rowData: RouteDetails) => "None",
        align: "left",
    },
    {
        id: "shipmentCount",
        headerTitle: "number of shipments",
        render: ({ shipmentCount }: RouteDetails) =>
            separateThousands(shipmentCount),
        align: "center",
        sortable: true,
    },
];
